import { useTable } from "react-table";
import { useContext, useMemo } from "react";
import { useState } from "react";
// import { mapUserRole } from "../../../helpers";
import { useGetUserList } from "../../../hooks/api/queries/useSettings";
import primaryComponents from "../../../components/primaryComponents";
import secondaryComponents from "..";
import { useCashierRestPinModeMutation } from "../../../hooks/api/mutations/useAuth";
import { ToastContext } from "../../../hooks/context";
import CopyToClipboard from "react-copy-to-clipboard";

const useUsersTableLogic = () => {
  const [userRole, setUserRole] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const restPinMutate = useCashierRestPinModeMutation();
  const [subAccountList, setsubAccountList] = useState([]);
  const [storeAccessList, setStoreAccessList] = useState([]);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [showDeleteUserModal, setShowDeleteUserModal] = useState(false);
  const triggerToast = useContext(ToastContext);

  const {
    isLoading: isFetchingUsers,
    data,
    refetch: fetchUsersList,
  } = useGetUserList();

  const handleRestPin = (id) => {
    restPinMutate.mutate(id, {
      onSuccess: (res) => {
        fetchUsersList();
        triggerToast(
          `Rest Successful! Access Code: ${res?.data?.data?.["access code"]}`,
          "success",
        );
      },
    });
  };

  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "first_name",
        Cell: ({ cell: { value, row } }) => (
          <span>
            {value} {row.original?.["last_name"]}
          </span>
        ),
      },
      {
        Header: "Email Address",
        accessor: "email",
      },
      {
        Header: "Sell Mode PIN",
        accessor: "access_code",
        Cell: ({ cell: { value } }) => {
          return value ? (
            <>
              <span
                style={{
                  background: "#1E016F",
                  color: "#fff",
                  paddingLeft: "5px",
                  paddingBottom: "5px",
                  paddingTop: "5px",
                  borderRadius: "4px",
                  letterSpacing: "6px",
                  display: "inline",
                  fontSize: 14,
                  fontFamily: "monospace",
                  textAlign: "center",
                  alignItems: "center",
                }}
              >
                {value}
              </span>
              <CopyToClipboard
                text={value}
                onCopy={() => triggerToast("Copied", "success")}
              >
                <span
                  className="ml-2 purple--text small-text-size"
                  style={{ cursor: "pointer" }}
                >
                  Copy Pin
                </span>
              </CopyToClipboard>
            </>
          ) : (
            "N/A"
          );
        },
      },
      {
        Header: "Role",
        accessor: "role",
        Cell: ({ cell: { value } }) => (
          <span
            style={{
              display: "inline",
              borderRadius: "6px",
              padding: "7px",
              width: "100px",
              maxWidth: "100px",
              fontSize: "12px",
              background: "#E8F7EE",
              color: "#19AE57",
            }}
          >
            {value?.charAt(0)?.toUpperCase() + value?.slice(1)?.toLowerCase()}
          </span>
        ),
      },

      {
        Header: "Actions",
        accessor: "",
        Cell: ({ cell: { row } }) => (
          <span
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <primaryComponents.Button
              onClick={() => {
                setUserEmail(row.original?.email);
                setUserRole(row.original?.role);
                setsubAccountList(row.original?.businesses_id);
                setStoreAccessList(row.original?.store_id);
                setShowInviteModal(true);
              }}
              classNames={"btn btn--primary smallBtn"}
            >
              Update
            </primaryComponents.Button>
            {/* rest pin */}
            <primaryComponents.Button
              onClick={() => {
                handleRestPin(row?.original?.id);
              }}
              classNames={"btn smallBtn btn--outline"}
              isLoading={restPinMutate.isLoading}
              isDisabled={restPinMutate.isLoading}
              loadingText={"Resting..."}
            >
              Reset PIN
            </primaryComponents.Button>

            {/* delete icon */}
            <secondaryComponents.NavigateWithPermission
              permissionParentKey={"Settings"}
              permissionChildKey="can_delete_users"
            >
              <primaryComponents.Button
                onClick={() => {
                  setUserEmail(row.original?.email);
                  setShowDeleteUserModal(true);
                }}
                classNames={"btn btn--outline-red smallBtn"}
              >
                Remove
              </primaryComponents.Button>
            </secondaryComponents.NavigateWithPermission>
          </span>
        ),
      },
    ],
    [],
  );

  const instance = useTable({ columns, data: data || [] });

  return {
    instance,
    isFetchingUsers,
    usersList: data || [],
    showInviteModal,
    setShowInviteModal,
    userRole,
    userEmail,
    subAccountList,
    setsubAccountList,
    setUserRole,
    setUserEmail,
    showDeleteUserModal,
    setShowDeleteUserModal,
    columns,
    storeAccessList,
    setStoreAccessList,
    fetchUsersList,
  };
};

export default useUsersTableLogic;
